import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './components';
import * as serviceWorker from './serviceWorker';
import { AppStateProvider } from './context/AppStateContext';

ReactDOM.render(
  <React.StrictMode>
    <AppStateProvider>
      <App />
    </AppStateProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
